const MONTHS_PL = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień']

export default function monthAsText (month, useT) {
    const monthPL = MONTHS_PL[month]
    const monthText = useT
        ? useT(monthPL)
        : monthPL
    return monthText
}